/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Promise from 'bluebird';
import _ from 'underscore';

import { range } from '@trello/arrays';
import { Analytics } from '@trello/atlassian-analytics';
import { customFieldsId as CUSTOM_FIELDS_ID } from '@trello/config';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { ModelCache } from 'app/scripts/db/ModelCache';
import { l } from 'app/scripts/lib/localize';
import { sendPluginUIEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { Util } from 'app/scripts/lib/util';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import { serializeCards } from 'app/scripts/views/internal/plugins/PluginModelSerializer';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PluginView } from 'app/scripts/views/plugin/PluginView';
import { ListSortTemplate } from 'app/scripts/views/templates/ListSortTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

import votingIconSvg from 'resources/images/powerups/voting-icon.svg';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const calculateMoves = ({ list, posBefore, posAfter }: any) =>
  Array.from(list).map((card, cardIndex) => ({
    card,
    pos:
      posBefore +
      ((cardIndex + 1) * (posAfter - posBefore)) / (list.length + 1),
  }));
// Figure out what moves need to happen to make all the cards in the list sort
// before the last item
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getMovesUp = function (list: any, idToPos: any) {
  let index = list.length - 1;

  return _.flatten(
    (() => {
      const result = [];
      while (index >= 0) {
        // Find the first card with a pos < posAfter
        const endIndex = index;
        index--;
        while (
          index >= 0 &&
          idToPos[list[index].id] > idToPos[list[endIndex].id]
        ) {
          index--;
        }

        result.push(
          calculateMoves({
            list: list.slice(index + 1, endIndex),
            posBefore: index >= 0 ? idToPos[list[index].id] : 0,
            posAfter: idToPos[list[endIndex].id],
          }),
        );
      }

      return result;
    })(),
  );
};

// Figure out what moves need to happen to make all the cards in the list sort
// after the first item
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getMovesDown = function (list: any, idToPos: any) {
  let index = 0;

  return _.flatten(
    (() => {
      const result = [];
      while (index < list.length) {
        // Find the first card with a pos > posBefore
        const startIndex = index;
        index++;
        while (
          index < list.length &&
          idToPos[list[index].id] < idToPos[list[startIndex].id]
        ) {
          index++;
        }

        result.push(
          calculateMoves({
            list: list.slice(startIndex + 1, index),
            posBefore: idToPos[list[startIndex].id],
            posAfter:
              index < list.length
                ? idToPos[list[index].id]
                : idToPos[list[startIndex].id] +
                  Util.spacing * (index - startIndex),
          }),
        );
      }

      return result;
    })(),
  );
};

const throttled = function (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  list: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { fx, updatesPerMinute, concurrency }: any,
) {
  // What's the least time we should spend on a concurrent
  // request to make sure we don't send more than
  // updatesPerMinute requests per minute
  const msWait = concurrency * ((60 * 1000) / updatesPerMinute);

  return Promise.map(
    list,
    function (entry) {
      const start = Date.now();

      return Promise.resolve(fx(entry)).then(function () {
        // Delay a bit so we don't send too many updates
        const msRemaining = msWait - (Date.now() - start);
        if (msRemaining > 0) {
          return Promise.delay(msRemaining);
        }
      });
    },
    { concurrency },
  );
};

interface ListSortView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginListSorters: any;
}

class ListSortView extends PluginView {
  static initClass() {
    this.prototype.viewTitleKey = 'sort list';
  }

  events() {
    return {
      'click .js-sort-by-due-date': 'sortByDueDate',
      'click .js-sort-newest-first': 'sortNewestFirst',
      'click .js-sort-oldest-first': 'sortOldestFirst',
      'click .js-sort-by-card-name': 'sortByCardName',
      'click .js-plugin-list-sort-action': 'sortByPluginSort',
    };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'sortListInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    return this.retain(this.options.pluginListSorters);
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let pluginListSorters = _.chain(this.options.pluginListSorters as any)
      .filter(
        (s) => _.isString(s.text) && s.text.length && _.isFunction(s.callback),
      )
      .map((s) =>
        Object.assign(s, {
          image: pluginIOCache.fromId(s.idPlugin).getIconUrl(),
          name: pluginIOCache.fromId(s.idPlugin).getName(),
        }),
      )
      .value();

    pluginListSorters = pluginListSorters.concat(this.getCustomFieldSorts());
    if (this.model.getBoard().isPowerUpEnabled('voting')) {
      pluginListSorters.push({
        callback: this.sortByVotes(),
        text: l('templates.list_sort.most-votes'),
        image: votingIconSvg,
        name: l('power ups.voting.name'),
      });
    }

    this.pluginListSorters = _.sortBy(pluginListSorters, 'text');

    this.$el.html(
      ListSortTemplate({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        canSortByDueDate: this.model.cardList.any((card: any) =>
          card.get('due'),
        ),
        pluginListSorters: this.pluginListSorters,
      }),
    );

    return this;
  }

  getCustomFieldSorts() {
    if (!this.model.getBoard().isCustomFieldsEnabled()) {
      return [];
    }

    return _.chain(this.model.getBoard().customFieldList.models)
      .filter((cf) => cf.isSortable() && cf.visible())
      .map((cf) => {
        if (cf.get('type') === 'number') {
          return [
            {
              // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
              callback: this.sortByCustomField(cf.id),
              text: l('templates.list_sort.field-ascending', {
                field: cf.get('name'),
              }),
              image: pluginIOCache.fromId(CUSTOM_FIELDS_ID).getIconUrl(),
              name: l('view title.custom fields'),
            },
            {
              callback: this.sortByCustomField(cf.id, true),
              text: l('templates.list_sort.field-descending', {
                field: cf.get('name'),
              }),
              image: pluginIOCache.fromId(CUSTOM_FIELDS_ID).getIconUrl(),
              name: l('view title.custom fields'),
            },
          ];
        } else {
          return {
            // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
            callback: this.sortByCustomField(cf.id),
            text: cf.get('name'),
            image: pluginIOCache.fromId(CUSTOM_FIELDS_ID).getIconUrl(),
            name: l('view title.custom fields'),
          };
        }
      })
      .flatten()
      .value();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortByDueDate(e: any) {
    stopPropagationAndPreventDefault(e);
    PopOver.hide();

    Analytics.sendTrackEvent({
      action: 'sorted',
      actionSubject: 'list',
      source: 'sortListInlineDialog',
      attributes: {
        method: 'by due date',
      },
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    return this.applySort(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return this.model.cardList.sortBy(function (card: any) {
        const due = card.get('due');
        const dueComplete = card.get('dueComplete');

        return [
          due ? (dueComplete ? '1' : '0') : '2',

          due != null ? due : '',
        ].join(':');
      });
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortNewestFirst(e: any) {
    stopPropagationAndPreventDefault(e);
    PopOver.hide();

    Analytics.sendTrackEvent({
      action: 'sorted',
      actionSubject: 'list',
      source: 'sortListInlineDialog',
      attributes: {
        method: 'by newest first',
      },
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    return this.applySort(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      () => this.model.cardList.sortBy((card: any) => card.id),
      {
        reverse: true,
      },
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortOldestFirst(e: any) {
    stopPropagationAndPreventDefault(e);
    PopOver.hide();

    Analytics.sendTrackEvent({
      action: 'sorted',
      actionSubject: 'list',
      source: 'sortListInlineDialog',
      attributes: {
        method: 'by oldest first',
      },
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    return this.applySort(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return this.model.cardList.sortBy((card: any) => card.id);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortByCardName(e: any) {
    stopPropagationAndPreventDefault(e);
    PopOver.hide();

    Analytics.sendTrackEvent({
      action: 'sorted',
      actionSubject: 'list',
      source: 'sortListInlineDialog',
      attributes: {
        method: 'by card name',
      },
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    return this.applySort(() => {
      // we'll need to restore the original comparator later, or else every new
      // card will not be inserted at the bottom of the list, but instead
      // alphabetically.
      const originalComparator = this.model.cardList.comparator;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.model.cardList.comparator = (card1: any, card2: any) =>
        card1.get('name').localeCompare(card2.get('name'));
      this.model.cardList.sort();
      this.model.cardList.comparator = originalComparator;
      return this.model.cardList.models;
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortByCustomField(idCustomField: any, descending: any) {
    return () => {
      Analytics.sendTrackEvent({
        action: 'sorted',
        actionSubject: 'list',
        source: 'sortListInlineDialog',
        attributes: {
          method: 'by custom fields',
        },
        containers: {
          list: {
            id: this.model.id,
          },
          board: {
            id: this.model.getBoard()?.id,
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id,
          },
        },
      });

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const withValue: any = [];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const withoutValue: any = [];
      _.forEach(this.model.cardList.models, function (c) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const fieldItem = c.customFieldItemList.find(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (cfi: any) => cfi.get('idCustomField') === idCustomField,
        );
        if (fieldItem != null && !fieldItem.isEmpty()) {
          return withValue.push({
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            id: c.id,
            value: fieldItem.getParsedValue(),
          });
        } else {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          return withoutValue.push(c.id);
        }
      });

      let sorted = _.chain(withValue)
        .sortBy((c) => c.value)
        .map((c) => c.id)
        .value();

      if (descending) {
        sorted = sorted.reverse();
      }

      sorted = sorted.concat(withoutValue);

      sorted = _.chain(sorted)
        .map((idCard, idx) => [idCard, idx])
        .object()
        .value();

      // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
      return this.applySort(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.model.cardList.sortBy((card: any) => sorted[card.id]);
      });
    };
  }

  sortByVotes() {
    return () => {
      Analytics.sendTrackEvent({
        action: 'sorted',
        actionSubject: 'list',
        source: 'sortListInlineDialog',
        attributes: {
          method: 'by votes',
        },
        containers: {
          list: {
            id: this.model.id,
          },
          board: {
            id: this.model.getBoard()?.id,
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id,
          },
        },
      });

      // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
      return this.applySort(() => {
        return this.model.cardList.sortBy(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (card: any) => card.get('badges').votes * -1,
        );
      });
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortByPluginSort(e: any) {
    stopPropagationAndPreventDefault(e);

    const index = $(e.target, this.$el)
      .closest('.js-plugin-list-sort-action')
      .data('index');
    const sort = this.pluginListSorters[index];

    if (sort.idPlugin) {
      const traceId = Analytics.startTask({
        taskName: 'run-pluginCommand/sortList',
        source: 'listMenuInlineDialog',
        attributes: {
          idPlugin: sort.idPlugin,
        },
      });
      sendPluginUIEvent({
        idPlugin: sort.idPlugin,
        idBoard: this.model.getBoard().id,
        event: {
          action: 'clicked',
          actionSubject: 'option',
          // @ts-expect-error TS(2322): Type '"powerUpListSorter"' is not assignable to ty... Remove this comment to see the full error message
          actionSubjectId: 'powerUpListSorter',
          source: 'listMenuInlineDialog',
        },
      });
      Alerts.show('sorting list', 'warning', 'listsort');
      sort
        .callback({
          options: {
            cards: serializeCards(this.model.cardList.models, ['all']),
          },
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          Analytics.taskFailed({
            taskName: 'run-pluginCommand/sortList',
            traceId,
            source: 'listMenuInlineDialog',
            attributes: {
              idPlugin: sort.idPlugin,
            },
            error,
          });
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((results: any) => {
          const sorted = results != null ? results.sortedIds : undefined;
          const actualCards = this.model.cardList.models;
          if (
            sorted == null ||
            !_.all(
              sorted,
              (idCard) => _.isString(idCard) && /^[a-f0-9]{24}$/.test(idCard),
            ) ||
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            !_.all(actualCards, (c) => Array.from(sorted).includes(c.id))
          ) {
            Alerts.hide('listsort');
            Alerts.show(
              'invalid sort order returned',
              'warning',
              'listsort',
              5000,
            );
            PopOver.hide();
            return;
          }

          const sortLookup = _.chain(sorted)
            // eslint-disable-next-line @typescript-eslint/no-shadow
            .map((idCard, index) => [idCard, index])
            .object()
            .value();
          Analytics.taskSucceeded({
            taskName: 'run-pluginCommand/sortList',
            traceId,
            source: 'listMenuInlineDialog',
            attributes: {
              idPlugin: sort.idPlugin,
            },
          });
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          return this.applySort(() => {
            return this.model.cardList.sortBy(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (card: any) => sortLookup[card.id],
            );
          });
        });
      return PopOver.hide();
    } else {
      sort.callback();
      return PopOver.hide();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  applySort(getDesiredCards: any, options: any) {
    if (options == null) {
      options = {};
    }
    if (this.model.cardList.length <= 1) {
      return;
    }

    Alerts.show('sorting list', 'warning', 'listsort');

    const desiredCards = getDesiredCards();
    if (options.reverse) {
      desiredCards.reverse();
    }

    // We're doing a lot of pos lookups, so use a simple hash
    const idToPos = _.chain(desiredCards)
      .map((card) => [card.id, card.get('pos')])
      .object()
      .value();

    // We want to optimize for changing as few positions as possible
    // so we'll choose PIVOT_COUNT cards where we sort everything before
    // and everything after, choose the pivot that results in the
    // fewest pos changes
    const PIVOT_COUNT = 10;

    const bestMoves = _.chain(range(0, PIVOT_COUNT, true))
      .map((index) => {
        return Math.round(((desiredCards.length - 1) * index) / PIVOT_COUNT);
      })
      .uniq()
      .map((index) => [
        ...Array.from(
          getMovesUp(desiredCards.slice(0, +index + 1 || undefined), idToPos),
        ),
        ...Array.from(getMovesDown(desiredCards.slice(index), idToPos)),
      ])
      .sortBy((entry) => entry.length)
      .first()
      .value();

    // Immediately update the UI
    // @ts-expect-error TS(2769): No overload matches this call.
    for (const { card, pos } of Array.from(bestMoves)) {
      card.set('pos', pos);
    }

    // Throttle updates so we aren't sending too many at once
    // Lock the model cache so if another sort is started
    // while this one is still running, we don't end up with
    // cards jumping around when the previous updates complete
    return Promise.using(ModelCache.getLock(), () =>
      throttled(bestMoves, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        fx({ card, pos }: any) {
          return Promise.fromNode((next) =>
            card.update('pos', card.get('pos'), next),
          );
        },
        updatesPerMinute: 300,
        concurrency: 5,
      }),
    ).then(function () {
      Alerts.hide('listsort');
      return Alerts.show('list sorted', 'info', 'listsort', 3000);
    });
  }
}

ListSortView.initClass();
export { ListSortView };
